<iframe id="ncteItem" width="100%" height="480" allow="autoplay"></iframe>
